import React, { Component } from 'react';
import { Link } from 'react-router';

/* eslint-disable */
export default class AccountStorage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      toggle: '',
    };

    this.handleSave = this.handleSave.bind(this);
  }

  handleSave() {
    console.log(123);
  }

  render() {
    return (
      <div className="panel-view">
        <div className="panel-view-header small">
          <div className="view-header-center">
            <h2>Storage</h2>
          </div>
          <div className="view-header-right">
            <Link onClick={this.handleSave}>
              <i className="icon icon-save" />
            </Link>
          </div>
        </div>
        <div className="panel-view-content">

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/storage/index.jsx